import { startOfWeek, format, parseISO } from "date-fns";

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function safeDate(d) {
  try { return typeof d === "string" ? parseISO(d) : new Date(d); } catch { return new Date(); }
}

export function groupByWeek(items, dateKey, amountKey) {
  const map = {};
  items.forEach((it) => {
    const dt = safeDate(it[dateKey]);
    const wk = format(startOfWeek(dt, { weekStartsOn: 1 }), "MMM d");
    map[wk] = (map[wk] || 0) + Number(it[amountKey] || 0);
  });
  return Object.entries(map).map(([label, value]) => ({ label, value })).slice(-12);
}

export function groupByMonth(items, dateKey, amountKey) {
  const map = {};
  items.forEach((it) => {
    const dt = safeDate(it[dateKey]);
    const m = format(dt, "MMM yyyy");
    map[m] = (map[m] || 0) + Number(it[amountKey] || 0);
  });
  return Object.entries(map).map(([label, value]) => ({ label, value })).slice(-12);
}
